import { Button, Grid, MenuItem, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";

export const MARITAL_STATUSES = [
    { value: "Not married", translationKey: "customers.maritalStatus.notMarried" },
    { value: "Married", translationKey: "customers.maritalStatus.married" },
    { value: "Widow/Widower", translationKey: "customers.maritalStatus.widow" },
    { value: "Divorced", translationKey: "customers.maritalStatus.divorced" },
];

export const FINANCIAL_STATUSES = [
    {
        value: "Separation of property",
        translationKey: "customers.financialStatus.separationOfProperty",
    },
    { value: "Marital union", translationKey: "customers.financialStatus.maritalUnion" },
];

export const PersonDetailsForm = (props) => {
    const { defaultValues, disabled = false, loading=false, onSubmit } = props;
    const { t } = useTranslation();
    const { control, handleSubmit, reset, register, setValue, watch } = useForm({
        defaultValues: {
            person_name: "",
            person_name2: "",
            person_surname: "",
            person_name_of_father: "",
            person_name_of_mother: "",
            person_maiden_surname: "",
            person_marital_status: "",
            person_financial_status: "",
            person_pesel: "",
            person_citizenship: "",
            ...defaultValues,
        },
    });

    // useEffect(() => {
    //     reset({
    //         person_name: defaultValues?.person_name ?? "",
    //         person_name2: defaultValues?.person_name2 ?? "",
    //         person_surname: defaultValues?.person_surname ?? "",
    //         person_name_of_father: defaultValues?.person_name_of_father ?? "",
    //         person_name_of_mother: defaultValues?.person_name_of_mother ?? "",
    //         person_maiden_surname: defaultValues?.person_maiden_surname ?? "",
    //         person_marital_status: defaultValues?.person_marital_status ?? "",
    //         person_financial_status: defaultValues?.person_financial_status ?? "",
    //         person_pesel: defaultValues?.person_pesel ?? "",
    //     });
    // }, [defaultValues, reset]);

    const isFormValid = watch("person_name") && watch("person_surname") && watch("person_pesel")

    return (
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                    <Controller
                        name="person_name"
                        control={control}
                        render={({ field, fieldState }) => (
                            <TextField
                                {...field}
                                label={t("customers.PersonDetailsDialog.name") + "*"}
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                                fullWidth
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Controller
                        name="person_name2"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label={t("customers.PersonDetailsDialog.name2")}
                                fullWidth
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Controller
                        name="person_surname"
                        control={control}
                        render={({ field, fieldState }) => (
                            <TextField
                                {...field}
                                label={t("customers.PersonDetailsDialog.surname") + "*"}
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                                fullWidth
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Controller
                        name="person_maiden_surname"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label={t("customers.PersonDetailsDialog.maidenSurname")}
                                fullWidth
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Controller
                        name="person_name_of_father"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label={t("customers.PersonDetailsDialog.nameOfFather")}
                                fullWidth
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Controller
                        name="person_name_of_mother"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label={t("customers.PersonDetailsDialog.nameOfMother")}
                                fullWidth
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={3}>
                    <Controller
                        name="person_citizenship"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label={t("customers.PersonDetailsDialog.personCitizenship")}
                                fullWidth
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={3}>
                    <Controller
                        name="person_marital_status"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label={t("customers.PersonDetailsDialog.maritalStatus")}
                                fullWidth
                                disabled={disabled}
                                onChange={(e)=> {
                                    if (e.target.value === "Not married")
                                        setValue("person_financial_status", null)
                                    field['onChange'](e)
                                }}
                            >
                                {MARITAL_STATUSES.map((opt) => (
                                    <MenuItem key={opt.value} value={opt.value}>
                                        {t(opt.translationKey)}
                                    </MenuItem>
                                ))}
                                <MenuItem key={null} value={null}>{"-"}</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={3}>
                    <Controller
                        name="person_financial_status"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label={t("customers.PersonDetailsDialog.financialStatus")}
                                fullWidth
                                disabled={disabled || watch("person_marital_status") === "Not married"}
                            >
                                {FINANCIAL_STATUSES.map((opt) => (
                                    <MenuItem key={opt.value} value={opt.value}>
                                        {t(opt.translationKey)}
                                    </MenuItem>
                                ))}
                                <MenuItem key={null} value={null}>{"-"}</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={3}>
                    <Controller
                        name="person_pesel"
                        control={control}
                        rules={{
                            validate: (v) =>
                                !v ||
                                /^\d{11}$/.test(v) ||
                                t("customers.PersonDetailsDialog.invalidPesel"),
                        }}
                        render={({ field, fieldState }) => (
                            <TextField
                                {...field}
                                label={t("customers.PersonDetailsDialog.pesel") + "*"}
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                                fullWidth
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12}>
                    <LoadingButton type="submit" variant="contained" color="primary" disabled={disabled || !isFormValid} loading={loading}>
                        {t("customers.PersonDetailsDialog.save")}
                    </LoadingButton>
                </Grid>
            </Grid>
        </form>
    );
};
